/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M4.5698 4.594c4.1036-4.1253 10.7568-4.1253 14.8604 0 4.1036 4.1254 4.1036 10.814 0 14.9394-.2913.2929-.2913.7677 0 1.0606a.7433.7433 0 0 0 1.0551 0c4.6863-4.7111 4.6863-12.3495 0-17.0606-4.6863-4.7112-12.2843-4.7112-16.9706 0-4.6863 4.7111-4.6863 12.3495 0 17.0606a.7432.7432 0 0 0 1.055 0c.2914-.2929.2914-.7677 0-1.0606-4.1035-4.1254-4.1035-10.814 0-14.9394Z"
    />
    <path
      fill="currentColor"
      d="M7.1686 10.0013V7.8585c-1.0682 1.2213-1.531 2.4887-1.3458 4.1425.2492 2.1652 1.5665 4.0473 3.4877 4.9959l.8355.4119-.0031 5.8432c-.0002.4142-.3344.7498-.7464.7497-.412-.0002-.7459-.3361-.7457-.7503l.0027-4.9077c-2.3824-1.1762-4.0065-3.5044-4.313-6.1716l-.0003-.0021c-.2768-2.4698.6268-4.2981 2.3148-5.9395a1.1677 1.1677 0 0 1 1.2996-.25c.4392.184.7168.6204.706 1.0938v2.9349c-.0064.9212.361 1.8024 1.0126 2.4369l.0052.005c.646.6413 1.5185.9857 2.4166.9571.8798-.0517 1.7084-.4451 2.3137-1.102.6077-.6591.9435-1.533.9349-2.4397l-.0001-.0072.0001-2.784c-.0117-.4737.2662-.9124.7084-1.0956a1.1713 1.1713 0 0 1 1.3047.2603c1.4577 1.4073 2.365 2.8634 2.3522 5.0527.0051 1.4718-.4005 2.9152-1.171 4.1632-.7706 1.2476-1.8747 2.2487-3.1845 2.8849v4.917c0 .4142-.334.75-.746.75s-.7461-.3357-.7461-.75v-5.8535l.8405-.4129c1.0543-.5116 1.9455-1.3181 2.5684-2.3266.6229-1.0089.9514-2.1775.9467-3.37l-.0001-.0077c.009-1.4085-.4503-2.4083-1.3811-3.4382v2.007c.0112 1.2863-.4652 2.529-1.3325 3.4698-.8682.9421-2.0617 1.509-3.3328 1.5807l-.0081.0004-.0082.0003c-1.3127.0451-2.584-.4569-3.5215-1.3861-.944-.9205-1.4726-2.1934-1.464-3.5197Z"
    />
  </React.Fragment>,
  'APIManagement'
);
